const media_centre = [
  {
    id: "media_centre_sign",
    image: "/Images/mediaCentre/media_centre_sign.png",
    alt: "MEDIA CENTRE Humanitarian Operations"
  }
]; 

export default media_centre;